// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"6352116d","334":"ea868f64","875":"b37fad64"}[chunkId] + ".chunk.js";
};